const styles = theme => ({
  container: {
    marginTop: 16
  },
  boldSubtitle: {
    fontWeight: 500
  },
  withBreaks: {
    whiteSpace: 'pre-line'
  },
  compactBullet: {
    fontSize: '12px',
    paddingTop: 0,
    paddingBottom: 0
  },
  bulletList: {
    marginBottom: 15
  },
  noDecorationLink: {
    color: theme.palette.primary.dark,
    textDecoration: 'none',
    '&:focus, &:hover, &:visited, &:link, &:active': {
      textDecoration: 'none'
    }
  }
});

export default styles;
